import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AdminProtectedRoute = ({ children, allow = [], permission }) => {
  const { adminToken, adminRole, adminPermissions } = useSelector(
    (state) => state.adminAuth,
  );

  // 🔴 Not logged in
  if (!adminToken) {
    return <Navigate to="/admin/login" replace />;
  }

  // ⏳ Permissions still loading → allow access temporarily
  if (adminPermissions === null) {
    console.log("⏳ Waiting for permissions...");
    return null; // OR loader
  }

  console.log("Checking permissions:", {
    userPermissions: adminPermissions,
    requiredPerm: permission,
    role: adminRole,
  });

  // 👑 Super admin bypass
  if (adminRole === "super_admin") {
    return children;
  }

  // 🎭 Role check
  if (allow.length && !allow.includes(adminRole)) {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  // 🔐 Permission check
  if (permission && !adminPermissions.includes(permission)) {
    return <Navigate to="/admin/unauthorized" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
